/**
 * Diagnostic Network HTTP Interceptor
 *
 * Story 15.12.1: Diagnostic Capture + AI Analysis
 * Epic 15.12: AI-Powered Feedback & Diagnostic System
 *
 * Перехватывает 4xx/5xx HTTP ответы для диагностического буфера.
 * ОТДЕЛЬНЫЙ от errorCaptureInterceptor. Fire-and-forget.
 */
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { DiagnosticCollectorService } from '../services/diagnostic-collector.service';

export const diagnosticNetworkInterceptor: HttpInterceptorFn = (req, next) => {
  const diagnosticCollector = inject(DiagnosticCollectorService);
  const startTime = Date.now();

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        try {
          if (error instanceof HttpErrorResponse && error.status >= 400) {
            // Формируем preview ответа (truncate до 512 bytes)
            let responsePreview = '';
            try {
              if (error.error) {
                const raw = typeof error.error === 'string'
                  ? error.error
                  : JSON.stringify(error.error);
                responsePreview = raw.length > 512
                  ? raw.slice(0, 509) + '...'
                  : raw;
              }
            } catch {
              responsePreview = error.message?.slice(0, 512) || '';
            }

            diagnosticCollector.addNetworkEntry({
              timestamp: new Date().toISOString(),
              url: req.url,
              method: req.method,
              status: error.status,
              duration_ms: Date.now() - startTime,
              response_preview: responsePreview,
            });
          }
        } catch {
          // Fire-and-forget: interceptor failure does NOT break HTTP pipeline
        }
      },
    })
  );
};
